import { ElLoading } from 'element-plus'
import { useLocale } from '@el-plus/hooks/use-locale'
const { t } = useLocale()

// 1. Loading 计数器与实例
let reqNum = 0
let loadingInstance
const startLoading = () => {
  if (reqNum === 0) {
    loadingInstance = ElLoading.service({
      lock: true,
      text: t('ep.loading.loading'),
      background: 'rgba(0, 0, 0, 0.7)',
    })
  }
  reqNum++
}
const endLoading = () => {
  if (reqNum <= 0) return
  reqNum--
  if (reqNum === 0 && loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}
export { startLoading, endLoading }
